import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  stateChartVariables: {
    sdohKey: null,
    stateCode: null,
    stateCountyCode: null
  }
}

const stateChartSlice = createSlice({
  name: 'stateChart',
  initialState,
  reducers: {
    setStateChartVariables: (state, action) => {
      state.stateChartVariables = action.payload
    },
    resetStateChartVariables: (state) => {
      state.stateChartVariables = {sdohKey: null, stateCode: null, stateCountyCode: null}
    }
  }
})

export const {setStateChartVariables, resetStateChartVariables} = stateChartSlice.actions

export default stateChartSlice.reducer

// Selectors
export const selectStateChartVariables = (state) => state.stateChart.stateChartVariables
